"use client"

import { useEffect } from "react"

import { usePathname } from "@/i18n/navigation"

/**
 * Hides the store footer (#store-footer) when the user navigates to the cart
 * page without a full page refresh. The cart page has its own fixed bottom
 * action bar (total + checkout), so the site footer would sit underneath it,
 * unreachable.
 *
 * This is a client-side complement to the server-side check in the (store)
 * layout — the server check handles initial render / full page loads, while
 * this hook handles client-side navigation between pages.
 */
export function FooterHider() {
  const pathname = usePathname()

  useEffect(() => {
    const footer = document.getElementById("store-footer")
    if (!footer) return

    if (pathname === "/cart") {
      footer.classList.add("hidden")
    } else {
      footer.classList.remove("hidden")
    }
  }, [pathname])

  return null
}
